module.exports = __webpack_public_path__ + "img/j_rpa.e999bb15.jpg";